import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sso-success",
  "use": "icon-sso-success-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-sso-success\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4 3.466c.295.221.354.64.133.934L8.04 11.725a1.333 1.333 0 0 1-2.09.054L3.154 8.427a.667.667 0 1 1 1.024-.854l2.793 3.352L12.467 3.6a.667.667 0 0 1 .933-.134Z\" fill=\"#069A49\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol